
export const getMaxDaysInMonth = (month, year) => {
  const monthInt = parseInt(month, 10);
  const yearInt = parseInt(year, 10);

  if (isNaN(monthInt) || isNaN(yearInt) || monthInt < 1 || monthInt > 12) {
    return 31; // Fallback to 31
  }

  return new Date(yearInt, monthInt, 0).getDate();
};

export const shouldPad = (part, val, digitsOnly) => {
  const num = parseInt(val, 10);
  if (isNaN(num)) return false;
    // console.log('part',part);
  if (part === 'MM') {
    return (val.length === 1 && num >= 2 && num <= 9) || (val.length === 2 && num > 12);
  }

  if (part === 'YYYY') {
    // Auto-pad if year is valid but incomplete (e.g., 1 digit when expecting 4)
    // Or if year exceeds max when partially entered
    const minYear = 1900;
    const maxYear = 2099;
    return (val.length < 4 && num >= minYear && num <= maxYear) || 
           (val.length === 4 && (num < minYear || num > maxYear));
  }

  if (part === 'DD') {
    const monthStr = digitsOnly.slice(0, 2);
    const yearStr = digitsOnly.slice(4, 8); // assuming MMDDYYYY
    const maxDays = getMaxDaysInMonth(monthStr, yearStr);
    return (val.length === 1 && num >= 4) || (val.length === 2 && num > maxDays);
  }
  if (part === 'HH') {
    // Hour: 00–23
    return (val.length === 1 && num >= 3) || (val.length === 2 && num > 23);
  }
  if (part === 'hh') {
    // Hour: 01–12
    return (val.length === 1 && num >= 2 && num <= 9) || (val.length === 2 && num > 12);
  }

  if (part === 'mm' || part === 'ss') {
    // Minute or Second: 00–59
    return (val.length === 1 && num >= 6) || (val.length === 2 && num > 59);
  }
  if(part ==='AM'){
    return true
  }

  return false;
};

export const correctSegmentValue = (part, val, digitsOnly) => {
    let num = parseInt(val, 10);
    
    if (isNaN(num)) return val;

    if (part === 'YYYY') {
      const minYear = 1900;
      const maxYear = 2099;
      // Clamp to min/max instead of returning current year
      if (num < minYear) return minYear.toString().padStart(4, '0');
      if (num > maxYear) return maxYear.toString().padStart(4, '0');
      return num.toString().padStart(4, '0');
    }
  
  
    if (part === 'MM') {
      if (num < 1) return '01';
      if (num > 12) return '12';
      return num.toString().padStart(2, '0');
    }
  
    if (part === 'DD') {
      const monthStr = digitsOnly.slice(0, 2);
      const yearStr = digitsOnly.slice(4, 8);
      const maxDays = getMaxDaysInMonth(monthStr, yearStr);
      if (num < 1) return '01';
      if (num > maxDays) return maxDays.toString().padStart(2, '0');
      return num.toString().padStart(2, '0');
    }
  
    if (part === 'HH') {
      if (num < 0) return '00';
      if (num > 23) return '23';
      return num.toString().padStart(2, '0');
    }
    if (part === 'hh') {
      if (num < 1) return '01';
      if (num > 12) return '12';
      return num.toString().padStart(2, '0');
    }
  
    if (part === 'mm' || part === 'ss') {
      if (num < 0) return '00';
      if (num > 59) return '59';
      return num.toString().padStart(2, '0');
    }
    return val;
  };

export const getSegmentPositions = (format , type=null) => {
 if (type === 'time') {
    // Assuming format = 'HH:mm A' or 'hh:mm A'
    const parts = [
      { part: 'hh', type: 'hour' },
      { part: 'mm', type: 'minute' },
      { part: 'AM', type: 'ampm' }, // Treat as 2 characters!
    ];
    const separators = [':', ' ']; // Separators between segments
    let pos = 0;
    return parts.map((segment, index) => {
      const start = pos;
      const end = start + segment.part.length;
      pos = end + (separators[index] ? separators[index].length : 0);
      return { part: segment.part, start, end, type: segment.type };
    });
  }
  const separatorMatch = format.match(/[^A-Za-z0-9]/);
  const separator = separatorMatch ? separatorMatch[0] : '/';
  const parts = format.split(separator);
  let pos = 0;

  return parts.map(part => {
    const start = pos;
    const end = start + part.length;
    pos = end + 1; // +1 for separator
    return { part, start, end };
  });
};

export const getSegmentPositionsDateTime = (format) => {
  const segments = [];
  let pos = 0;

  // Match known format tokens or separators
  // const regex = /(YYYY|MM|DD|HH|mm|ss|S{1,3}|[^A-Za-z]+)/g;
  const regex = /(YYYY|YY|MMMM|MMM|MM|M|DD|D|HH|mm|ss|S{1,3}|[^A-Za-z]+)/g;



  let match;

  while ((match = regex.exec(format))) {
    const [part] = match;
    const isToken = /^[A-Za-z]+$/.test(part);
    const start = pos;
    const end = start + part.length;

    if (isToken) {
      segments.push({ part, start, end });
    }

    pos = end;
  }

  return segments;
};

export const getDefaultValue = (format, type=null) => {
  if (type === 'time') {
    // For format like "HH:mm A" → default: "__:__ __"
    return '__:__ __';
  }
  const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
  const parts = format.split(separator);
  // console.log('parts',parts);
  
  return parts.map(p => '_'.repeat(p.length)).join(separator);
};

export const getDefaultValueDateTime = (format) => {
  return format.replace(/[A-Za-z]/g, '_');

  // const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
  // const parts = format.split(separator);
  // // console.log('parts',parts);
  
  // return parts.map(p => '_'.repeat(p.length)).join(separator)+'__:__:__';
};
